module.exports = __webpack_public_path__ + "static/media/achieve3.fa465147.PNG";